import React from 'react';
import MetaData from './MetaData';
import History from './History';
import DragToUpload from './DragToUpload';
import Preview from './Preview';

export function SidePanel(props) {
    const { isAdmin, node, onUpload, isView, tag } = props;
    const isFolder = node && node.hasChildren;
    const name = node && node.name;
    const isAllowUpload = node && ( (isAdmin && isFolder) || (name && name.includes("Upload")));
    const fileType = node ? node.type : null;
    const filePath = node ? 'api/docx/download/' + node.id : null;

    return isFolder ?
        (<div style={{ height: '65vh' }}>

            <MetaData rows={tag.meta} />
            {
                isAdmin ? <History rows={tag.history} /> : ''
            }
            {
                isAllowUpload ? <DragToUpload onUpload={onUpload} /> : ''
            }

        </div>) :
        (<div style={{ height: '65vh' }}>
            <MetaData rows={tag.meta} />
            {
                isAdmin ? <History rows={tag.history} /> : ''
            }
            {isView ?
                <Preview fileType={fileType} filePath={filePath} /> : ''}
        </div>);
}